// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNavigation_link__Zx1Rt","activeLink":"AuthNavigation_activeLink__3smw7 AuthNavigation_link__Zx1Rt"};